
/**
 * Niiko Storage Service - IndexedDB Implementation
 * Substitui o localStorage para suportar armazenamento em larga escala (Imagens/Vídeos Base64).
 */

const DB_NAME = 'NiikoArtworkDB';
const DB_VERSION = 6; // Versão incrementada para adicionar stores de deleção
const STORES = ['arts', 'orders', 'chats', 'comments', 'session', 'users', 'category_covers', 'deleted_orders', 'deleted_chats', 'deleted_arts'];

export class StorageService {
  private db: IDBDatabase | null = null;

  private async getDB(): Promise<IDBDatabase> {
    if (this.db) return this.db;

    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        STORES.forEach(store => {
          if (!db.objectStoreNames.contains(store)) {
            db.createObjectStore(store);
            console.log(`Store criada: ${store}`);
          }
        });
      };

      request.onsuccess = (event) => {
        this.db = (event.target as IDBOpenDBRequest).result;
        resolve(this.db);
      };

      request.onerror = (event) => {
        console.error('Erro IndexedDB:', event);
        reject('Erro ao abrir IndexedDB');
      };
    });
  }

  async save(storeName: string, data: any, key: string = 'data'): Promise<void> {
    const db = await this.getDB();
    return new Promise((resolve, reject) => {
      try {
        const transaction = db.transaction([storeName], 'readwrite');
        const store = transaction.objectStore(storeName);
        const request = store.put(data, key);

        request.onsuccess = () => resolve();
        request.onerror = () => reject(`Erro ao salvar em ${storeName}`);
      } catch (e) {
        reject(`Store ${storeName} não encontrada no banco de dados.`);
      }
    });
  }

  async load(storeName: string, key: string = 'data'): Promise<any> {
    const db = await this.getDB();
    return new Promise((resolve, reject) => {
      try {
        const transaction = db.transaction([storeName], 'readonly');
        const store = transaction.objectStore(storeName);
        const request = store.get(key);

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(`Erro ao carregar de ${storeName}`);
      } catch (e) {
        console.warn(`Tentativa de carregar store inexistente: ${storeName}`);
        resolve(null);
      }
    });
  }

  async clearAll(): Promise<void> {
    const db = await this.getDB();
    return new Promise((resolve) => {
      const transaction = db.transaction(STORES, 'readwrite');
      STORES.forEach(s => {
        if (db.objectStoreNames.contains(s)) {
          transaction.objectStore(s).clear();
        }
      });
      transaction.oncomplete = () => resolve();
    });
  }
}

export const storage = new StorageService();
